export const providerPrefix = '/provider-api/extranet/providers';
export const providerGroupPrefix = '/provider-api/extranet/providerGroups';
export const internalPrefix = '/provider-api/extranet';
export const bookingPrefix = '/extranet/reservation';
export const supplierBatchPrefix = '/supplier-batch';
export const notification = '/notification-gateway-api/extranet';

export default providerPrefix;
